<template>
  <li
    class="main-item point"
    @click="$emit('changeActiveComponent')"
  >
    <a
      class="main-item-link point"
      :class="{active: isActive}"
    >
      Browse by practice area
      <img
        class="icon"
        src="../../../images/down-arrow.svg"
        alt=""
      >
    </a>

    <ul
      class="sub-list hide"
      :class="{show: isActive}"
    >
      <li
        v-for="spec in specializations"
        :key="spec.id"
        class="sub-list-item"
      >
        <router-link
          :to="`/lawyer-list?area=${spec.name}`"
          class="name"
        >
          {{ spec.name }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import {computed, onMounted} from 'vue'
import {useSpecializationStore} from '@/store'

export default {
  name: 'BrowseByPracticeArea',
  props: {
    active: {
      type: String,
      default: 'ByName',
    },
  },
  setup(props) {
    const specializationStore = useSpecializationStore()

    onMounted(async () => {
      await specializationStore.getAllSpecialization()
    })

    const specializations = computed(() =>specializationStore.allSpecialization )

    const isActive = computed(() => props.active === 'ByPracticeArea')

    return {
      specializations,
      isActive,
    }
  },
}
</script>

<style lang="scss" scoped>
.sub-list {
  max-height: 350px;
  margin: 1rem 0;
  overflow-y: auto;
  padding: 0 2rem;

  .sub-list-item {
    margin-bottom: 0;
    float: left;
    width: calc(100% / 4);
    padding-right: 30px;

    .name {
      margin: 10px 0 0;
    }
  }
}
@media (max-width: 767px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 499px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 400px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 1);
      padding-right: 0;
    }
  }
}
</style>
